import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconClaim = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 49,
	height: 48,
	viewBox: "0 0 49 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_8274_2317)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M22.7852 5.14285C13.3175 5.14285 5.64233 12.818 5.64233 22.2857C5.64233 31.7534 13.3175 39.4286 22.7852 39.4286C32.2529 39.4286 39.928 31.7534 39.928 22.2857C39.928 12.818 32.2529 5.14285 22.7852 5.14285Z",
			fill: "#A5BAC9"
		}), /* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M22.7852 5.14286C13.3175 5.14286 5.64237 12.818 5.64237 22.2857C5.64237 31.7534 13.3175 39.4286 22.7852 39.4286C32.253 39.4286 39.9281 31.7534 39.9281 22.2857C39.9281 12.818 32.253 5.14286 22.7852 5.14286ZM0.499512 22.2857C0.499512 9.97766 10.4772 0 22.7852 0C35.0935 0 45.0709 9.97766 45.0709 22.2857C45.0709 27.2026 43.4787 31.7476 40.7815 35.4333L47.496 42.1478C48.8352 43.4866 48.8352 45.6576 47.496 46.9965C46.1571 48.3353 43.9865 48.3353 42.6473 46.9965L35.9328 40.2819C32.2472 42.9792 27.7021 44.5714 22.7852 44.5714C10.4772 44.5714 0.499512 34.5939 0.499512 22.2857ZM13.0799 18.6214L21.7832 11.5006C22.3661 11.0236 23.2044 11.0236 23.7873 11.5006L32.4906 18.6214C32.8579 18.922 33.0709 19.3715 33.0709 19.8461V26.967C33.0709 29.5889 30.9455 31.7143 28.3237 31.7143H17.2468C14.6249 31.7143 12.4995 29.5889 12.4995 26.967V19.8461C12.4995 19.3715 12.7126 18.922 13.0799 18.6214Z",
			fill: "#5A7181"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_8274_2317",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 48.0009,
			height: 48.0006,
			fill: "white",
			transform: "translate(0.499512)"
		})
	}) })]
});
export default SvgIconClaim;
